<script>
import DetailMasterBlueprint from "@/router/views/dashboard-pegawai/components/master-blueprint/detail-master-blueprint.vue";
import appConfig from "@/app.config";

export default {
  name: "DetailBlueprintPeserta",
  page: {
    title: "Detail Blueprint",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    DetailMasterBlueprint,
  },
  computed: {
    idkompetensi() {
      return this.$route.params.idkompetensi || this.$route.query.idkompetensi;
    },
  },
  methods: {
    handleBack() {
      window.close();
      setTimeout(() => {
        if (window.history.length > 1) {
          window.history.back();
        } else {
          this.$router.push({ name: "dashboard-assesmen-hc" });
        }
      }, 150);
    },
  },
};
</script>

<template>
  <div class="detail-blueprint-page">
    <!-- NAVBAR (Identik dengan header branding Asesmen HC) -->
    <div class="mym-navbar">
      <div class="mym-navbar-inner">
        <div class="mym-navbar-brand">
          <div class="mym-navbar-logo">
            <img
              src="/logo_pln.png"
              alt="Logo PLN"
              style="height: 40px; object-fit: contain;"
            />
          </div>

          <div class="mym-navbar-text">
            <div class="mym-navbar-title">Asesmen Hard Competency</div>
            <div class="mym-navbar-subtitle">Unit Pelaksana Sertifikasi</div>
          </div>
        </div>

        <div class="mym-navbar-action">
          <a href="javascript:void(0)" @click="handleBack()">
            <i class="fas fa-times me-1"></i>
            Tutup Halaman
          </a>
        </div>
      </div>
    </div>

    <!-- MAIN AREA -->
    <div class="mym-main-area">
      <div class="container-fluid px-0">
        <div v-if="!idkompetensi" class="alert alert-warning text-center">
          <i class="fas fa-exclamation-triangle me-2"></i> ID Kompetensi tidak ditemukan.
        </div>
        <DetailMasterBlueprint
          v-else
          :idkompetensi="idkompetensi"
          breadcrumbParent="Dashboard Asesmen"
          bannerTitle="Detail Blueprint Kompetensi"
          @back="handleBack"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.detail-blueprint-page {
  min-height: 100vh;
  background-color: #f8fafc;
}
</style>
